import { FaMinus, FaPlus } from "react-icons/fa6";

import React from "react";
import { useTranslation } from "react-i18next";

const AddonItem = ({
  addon,
  selectedAddons,
  handleAddonQuantityChange,
  handleAddonChange,
}) => {
  const { i18n } = useTranslation();
  return (
    <div className="flex flex-col items-center mb-2 justify-center">
      <input
        type="checkbox"
        id={`addon-${addon.id}`}
        className="hidden"
        onChange={(e) => handleAddonChange(addon, e.target.checked)}
      />
      <label htmlFor={`addon-${addon.id}`} className="mb-7 cursor-pointer">
        <div
          className={`w-[7.625rem] h-[9.375rem] 
                  rounded-2xl gap-1 flex flex-col 
                 `}
        >
          <img
            src={addon.website_image}
            alt={
              i18n.language === "en" ? addon?.english_name : addon?.arabic_name
            }
            className={`w-full h-[7rem] object-cover rounded-2xl
                      ${
                        selectedAddons.some((item) => item.id === addon.id)
                          ? "border-2 border-blue-500"
                          : "border-0 "
                      }`}
          />
          <div className="flex flex-col w-full px-3 gap-1">
            <h3 className="text-xs font-semibold">
              {i18n.language === "en"
                ? addon?.english_name
                : addon?.arabic_name}
            </h3>
            <p className="text-gray-500 text-xs">
              {addon.price} {i18n.language === "en" ? "SAR" : "ر.س"}
            </p>
          </div>
        </div>
      </label>
      {selectedAddons.some((item) => item.id === addon.id) && (
        <div className="flex items-center justify-center w-full">
          <button
            className={`px-2 py-1 border  text-sm 
                      flex items-center justify-center ${
                        i18n.language === "en"
                          ? "rounded-l-full"
                          : "rounded-r-full"
                      }`}
            onClick={() =>
              handleAddonQuantityChange(
                addon.id,
                Math.max(
                  1,
                  selectedAddons.find((item) => item.id === addon.id).quantity -
                    1
                )
              )
            }
          >
            <FaMinus />
          </button>
          <input
            type="number"
            className={`w-10 text-center flex items-center justify-center
                       py-1   ${
                         i18n.language === "en" ? "pl-3" : "pr-3"
                       } text-sm`}
            value={selectedAddons.find((item) => item.id === addon.id).quantity}
            onChange={(e) =>
              handleAddonQuantityChange(
                addon.id,
                Math.max(1, parseInt(e.target.value) || 1)
              )
            }
            min="1"
          />
          <button
            className={`px-2 py-1 border  text-sm 
                      flex items-center justify-center ${
                        i18n.language === "en"
                          ? "rounded-r-full"
                          : "rounded-l-full"
                      }`}
            onClick={() =>
              handleAddonQuantityChange(
                addon.id,
                selectedAddons.find((item) => item.id === addon.id).quantity + 1
              )
            }
          >
            <FaPlus />
          </button>
        </div>
      )}
    </div>
  );
};
export default AddonItem;
